<template>
  <div style="background: #1B1C22">
    <div class="no-page flex-center">
      Sorry!The Page you’re looking for cannot be found. <router-link class="inline-block" to="/">Go to Homepage</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "errorPage",
  created() {
    // window.document.documentElement.setAttribute("dir", 'ltr');
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/css/variable";
@import "../assets/css/mixin";
.no-page {
  margin: 0 auto;
  max-width: 1200px;
  min-height: 100vh;
  background: url("#{$variableName}static/images/404.png") no-repeat center;
  background-size: contain;
  justify-content: center;
  font-size: $font-size-normal;
  color: #FFF;
  letter-spacing: 0.5px;
  a{
    color: $font-active-color;
    padding-bottom: 1px;
    border-bottom: 1px solid $border-color-active;
    margin-left: 10px;
  }
}
</style>
